const en = {
  'Project detail': 'Project Detail',
}

export default en;